import { useSnackbarContext } from '../../../../lib/context/SnackbarContext';
import Notification from '../Notification/Notification';
import styles from './SnackbarMessage.module.scss';
import { notificationsIds } from '../../../../lib/tests/testIds';

const SnackbarMessage = () => {
  const { message, type, isOpen, close, handleExited } = useSnackbarContext();

  return (
    <Notification
      content={message}
      type={type}
      open={isOpen}
      onClickHandler={close}
      transitionAnimation
      onExited={handleExited}
      wrapperClass={styles.snackbarContainer}
      contentClass={styles.text}
      ariaRole="alert"
      data-testid={notificationsIds.snackbarMessage}
    />
  );
};

export default SnackbarMessage;
